<template>
  <div class="container-fluid bg-gray-30 rounded mb-4">
    <div class="row py-4 justify-content-center">
      <div class="col-12 alert mb-0" v-if="hideResults">
        <p class="small text-center text-primary mb-0">
          {{ __("lang.kwl.building_geometry_result.info") }}
        </p>
      </div>
      <div class="col-12" v-else>
        <div v-if="configuration.norms_id==1">
          <b-table
            :fields="building_geometry_result_field"
            :items="units"
            class="table table-sm table-borderless"
            responsive
            tbody-class="align-middle"
            thead-class="small"
          >
            <template #cell(storey)="row">
              {{ getLangKey("floors", row.item.storey).text }}
              {{ row.item.level }}
            </template>
            <template #cell(infiltration)="row">
              <input
                v-model="row.item.infiltrationString"
                class="form-control slim mx-auto"
                disabled
                name="infiltration"
                type="text"
              />
            </template>
            <template #cell(compare)="row">
            <span
              v-if="row.item.infiltration <= row.item.moisureProtection"
              class="h4 text-primary mb-0"
            >&lt;</span
            >
              <span v-else class="h4 text-primary mb-0">&gt;</span>
            </template>
            <template #cell(moisure_protection)="row">
              <input
                v-model="row.item.moisureProtectionString"
                class="form-control slim mx-auto"
                disabled
                name="feuchteschutz"
                type="text"
              />
            </template>
            <template #cell(ergo)="row">
              <div class="align-middle text-center">
                <span class="h4 text-primary mb-0">→</span>
              </div>
            </template>
            <template #cell(needLtm)="row">
              <input
                v-if="row.item.infiltration <= row.item.moisureProtection"
                :value="__('lang.kwl.building_geometry_result.yes')"
                class="form-control slim font-weight-bold text-center mx-auto"
                disabled
              />
              <input
                v-else-if="
                row.item.infiltration > row.item.moisureProtection &&
                row.item.windowless == true
              "
                :value="__('lang.kwl.building_geometry_result.yes') + '*'"
                class="form-control slim font-weight-bold text-center mx-auto"
                disabled
              />
              <input
                v-else
                :value="__('lang.kwl.building_geometry_result.no')"
                class="form-control slim font-weight-bold text-center mx-auto"
                disabled
              />
            </template>
            <template #cell(space)="row">
              <div class="dropdown d-inline">
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  class="btn btn-sm btn-gray-50 text-white border-0 dropdown-toggle no-arrow"
                  data-display="static"
                  data-toggle="dropdown"
                  type="button"
                >
                  ...
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right bg-secondary border-0"
                >
                  <a
                    v-if="building.type == 1"
                    class="dropdown-item text-center"
                    data-content="ltm-duplicate"
                    data-target="#ltmMultiModal"
                    data-toggle="modal"
                    role="button"
                    @click="setData('LtmDuplicate', row.item.id)"
                  >{{ __("lang.kwl.building_geometry_result.copy_ltm") }}</a
                  >
                  <a
                    v-if="building.type == 1"
                    class="dropdown-item text-center"
                    role="button"
                    @click="
                    setIdenticalLtm(row.item.ventilationMeasure, row.item.id)
                  "
                  >{{ __("lang.kwl.building_geometry_result.same_ltm") }}</a
                  >
                  <a
                    class="dropdown-item text-center"
                    role="button"
                    @click="setPrintData(row.item.id)"
                  >{{ __("lang.kwl.building_geometry_result.print") }}</a
                  >
                </div>
              </div>
            </template>
            <template #row-details="row">
              <table style="width: 100%">
                <tr>
                  <th class="small" colspan="8">
                    {{ __("lang.kwl.building_geometry_result.ltm_selection") }}:
                  </th>
                </tr>
                <tr>
                  <td class="align-middle" style="width: 10%">
                    <div v-if="configuration.norms_id==1">
                      <button
                        class="btn btn-primary btn-block btn-sm asd"
                        data-content="ventilation-edit"
                        data-target="#ltmMultiModal"
                        data-toggle="modal"
                        @click="setData('LtmDe', row.item.id)"
                      >
                        {{ __("lang.kwl.building_geometry_result.choose") }}
                      </button>
                    </div>
                    <div v-else>
                      <button
                        class="btn btn-primary btn-block btn-sm asd"
                        data-content="ventilation-edit"
                        data-target="#ltmMultiModal"
                        data-toggle="modal"
                        @click="setData('LtmAt', row.item.id)"
                      >
                        {{ __("lang.kwl.building_geometry_result.choose") }}
                      </button>
                    </div>
                  </td>
                  <td class="align-middle" colspan="7">
                    <ul class="list-unstyled square square-small mb-0 ml-3 small">
                      <li
                        v-if="
                        row.item.ventilationMeasure == 1 ||
                        row.item.ventilationMeasure == 7
                      "
                      >
                        {{
                          __(
                            "lang.building_data.ventilation_measures.fan_assisted_ventilation"
                          )
                        }}
                        - {{ __("lang.output.exhaust.air.DIN.section") }}
                      </li>
                      <li v-if="row.item.ventilationMeasure == 2">
                        {{
                          __(
                            "lang.building_data.ventilation_measures.fan_assisted_ventilation"
                          )
                        }}
                        - {{ __("lang.output.exhaust.air.DIN") }}
                      </li>
                      <li v-if="row.item.ventilationMeasure == 3">
                        {{
                          __(
                            "lang.building_data.ventilation_measures.fan_assisted_ventilation"
                          )
                        }}
                        - {{ __("lang.kwl.ltm.wrg") }} -
                        {{ __("lang.kwl.ltm.unit_central") }}
                      </li>
                      <li v-if="row.item.ventilationMeasure == 4">
                        {{
                          __(
                            "lang.building_data.ventilation_measures.fan_assisted_ventilation"
                          )
                        }}
                        - {{ __("lang.kwl.ltm.wrg") }} -
                        {{ __("lang.kwl.ltm.building_central") }}
                      </li>
                      <li v-if="row.item.ventilationMeasure == 5"></li>
                      <li v-if="row.item.ventilationMeasure == 6">
                        {{
                          __(
                            "lang.building_data.ventilation_measures.fan_assisted_ventilation"
                          )
                        }}
                        - {{ __("lang.kwl.ltm.combi") }} -
                        {{ __("lang.kwl.ltm.decentral") }}
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td colspan="8">
                    <hr/>
                  </td>
                </tr>
              </table>
            </template>
          </b-table>
          <!--                 <p class="text-center">
                      <button class="btn btn-primary text-white" @click="setPrintData">
                          <svg class="icon">
                              <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                          </svg>
                          {{ __("lang.kwl.building_geometry_result.print") }}
                      </button>
                  </p> -->
        </div>
        <div v-else>
          <div class="row mb-3" v-for="unit in units" :key="unit.it">
            <div class="col-12">
              <p>{{ __("lang.kwl.building_geometry_result.ltm_selection") }}:</p>
            </div>
            <div class="col-12 col-md-1">
              <div v-if="configuration.norms_id==1">
                <button class="btn btn-primary btn-sm bbb" data-toggle="modal" data-target="#ltmMultiModal"
                        @click="setData('LtmDe', unit.id)" data-content="ventilation-edit">
                  {{ __("lang.kwl.building_geometry_result.choose") }}

                </button>
              </div>
              <div v-else>
                <button class="btn btn-primary btn-sm aaaa" data-toggle="modal" data-target="#ltmMultiModal"
                        @click="setData('LtmAt', unit.id)" data-content="ventilation-edit">
                  {{ __("lang.kwl.building_geometry_result.choose") }}

                </button>
              </div>
            </div>
            <div class="col-12 col-md-11">
              <ul class="list-unstyled square square-small mb-0 ml-3 small">
                <li v-if="unit.ventilationMeasure == 1 || unit.ventilationMeasure == 7">
                  <div v-if="configuration.norms_id==1">

                    {{ __('lang.building_data.ventilation_measures.fan_assisted_ventilation') }} -
                    {{ __('lang.output.exhaust.air.DIN.section') }}
                  </div>
                  <div v-else>
                    {{ __('lang.kwl.ltm.6036') }}
                  </div>
                </li>
                <li v-if="unit.ventilationMeasure == 2">
                  {{ __('lang.building_data.ventilation_measures.fan_assisted_ventilation') }} -
                  {{ __('lang.output.exhaust.air.DIN') }}
                </li>
                <li v-if="unit.ventilationMeasure == 3">
                  {{ __('lang.building_data.ventilation_measures.fan_assisted_ventilation') }} -
                  {{ __('lang.kwl.ltm.wrg') }} - {{ __('lang.kwl.ltm.unit_central') }}
                </li>
                <li v-if="unit.ventilationMeasure == 4">
                  {{ __('lang.building_data.ventilation_measures.fan_assisted_ventilation') }} -
                  {{ __('lang.kwl.ltm.wrg') }} - {{ __('lang.kwl.ltm.building_central') }}
                </li>
                <li v-if="unit.ventilationMeasure == 5">
                </li>
                <li v-if="unit.ventilationMeasure == 6">
                  {{ __('lang.building_data.ventilation_measures.fan_assisted_ventilation') }} -
                  {{ __('lang.kwl.ltm.combi') }} - {{ __('lang.kwl.ltm.decentral') }}
                </li>
              </ul>
            </div>


          </div>

        </div>


        <!--                 <p class="text-center">
            <button class="btn btn-primary text-white" @click="setPrintData">
                <svg class="icon">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                {{ __("lang.kwl.building_geometry_result.print") }}
            </button>
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import Building from "@models/building/Building";
import Unit from "@models/building/Unit";
import {getLangKey, setLabels} from "@services/helpers/langHandler";
import Room from "@models/building/Room";
import LtmHasRoomtypeHasRoomltm from "@models/helpers/LtmHasRoomtypeHasRoomltm";
import Configuration from "@models/project/Configuration";

export default {
  data() {
    return {};
  },
  methods: {
    getLangKey: getLangKey,
    setLabels: setLabels,

    setData(componentName, unitId) {
      this.$store.dispatch("modalSettings/setComponent", componentName);
      this.$store.dispatch("modalSettings/isLarge", false);
      this.$store.dispatch("modalSettings/callRef", {id: unitId});
      this.$store.dispatch("modalSettings/open");
    },

    setIdenticalLtm(unitLtm, unitId) {
      this.units.forEach((unit) => {
        if (unitId == unit.id) {
          return;
        }
        unit.ventilationMeasure = unitLtm;
        if (Room.query().where("unitId", unit.id).count() > 0) {
          this.checkRoomLTM(unit, unitLtm);
        }
        unit.deleteArticles();
        unit.airvolumeUpdate = true;
        Unit.update(unit);
      });
    },
    deleteTableHeaders: function (tableHeaders, itemList) {
      itemList.forEach(function (item) {
        var index = -1;
        index = tableHeaders.findIndex((field) => field.key == item);
        if (index > -1) {
          tableHeaders.splice(index, 1);
        }
      });
      return tableHeaders;
    },

    setPrintData(unitId) {
      this.$store.dispatch("modalSettings/setComponent", "PrintPDF");
      this.$store.dispatch("modalSettings/isLarge", false);
      this.$store.dispatch("modalSettings/callRef", {id: unitId});
      this.$store.dispatch("modalSettings/open");
    },

    checkRoomLTM(unit, unitLtm) {
      if (unit.rooms.length <= 0) return;
      unit.rooms.forEach((room) => {
        var ltmHasRoomtypeHasRoomltm = LtmHasRoomtypeHasRoomltm.query()
          .where((e) => {
            return (
              e.ltms_id == unitLtm &&
              e.roomtypes_id == room.type &&
              e.default == 1
            );
          })
          .first();
        if (!ltmHasRoomtypeHasRoomltm) {
          Room.delete(room.id);
          this.$store.dispatch("alert/setAlert", {
            type: "info",
            message:
              "Räume die in dieser LTM nicht zur verfügung stehen wurden gelöscht",
          });
          return;
        }
        room.ventilationMeasure = ltmHasRoomtypeHasRoomltm.roomltms_id;
        if (
          room.ventilationMeasure == 6 ||
          room.ventilationMeasure == 1 ||
          room.ventilationMeasure == 3
        ) {
          room.deviceInstallation = 10;
        } else {
          room.deviceInstallation = 4;
        }
        room.window = ltmHasRoomtypeHasRoomltm.window;
      });
    },
  },
  computed: {
    building() {
      return Building.query().first();
    },
    units() {
      var units = Unit.query().with(["rooms"]).all();
      units.forEach((unit) => (unit["_showDetails"] = true));
      return units;
    },
    hideResults() {
      var hide = false;
      this.units.forEach(function (unit) {
        if (isNaN(unit.moisureProtection) || unit.moisureProtection <= 0 || unit.moisureProtection == null) hide = true;
        if (isNaN(unit.infiltration) || unit.infiltration <= 0 || unit.infiltration == null) hide = true;
      });
      return hide;
    },
    building_geometry_result_field: {
      get() {
        var inputFields = JSON.parse(JSON.stringify(this.$store.state.inputs.building_geometry_result_field)
        );
        if (this.building.type == 0) {
          inputFields = this.deleteTableHeaders(inputFields, ["storey"]);
        }
        return this.setLabels(inputFields);
      },
    },
    norms: {
      get() {
        return this.$store.state.session.norms
      },
    },

    configuration() {
      return Configuration.query().with(['project']).first()
    },
  },
};
</script>
